import React from "react";

const ImageDisplay = ({
  path = null,
  minioPath = null,
  imageStyle,
  classNameCss,
}) => {
  const source = minioPath || path;

  if (source) {
    return (
      <img
        className={classNameCss}
        src={source}
        style={imageStyle}
        alt="Preview"
        loading="lazy"
      />
    );
  }

  return null;
};

export default ImageDisplay;
